// extracted by mini-css-extract-plugin
module.exports = {"burger":"burger-module--burger--1CJ3B","active":"burger-module--active--2v9BH","inner":"burger-module--inner--3v_7p","box":"burger-module--box--12oSh"};